import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { map } from 'rxjs';

@Injectable()
export class FornecedoresRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.FORNECEDORES);
  }

    fornecedores(nome: string) {
      return this.getRequest<{ data: { results: any[]; count: number } }>({
        nome,
        page: 1,
        limit: 10,
      }).pipe(
        map(({ data }) =>
          data.results.map((fornecedor: any) => ({
            value: fornecedor.id,
            label: fornecedor.pessoa.nomeFantasia,
          })),
        ),
      );
    }
}
